export default {
    title: 'موقع مندوب المبيعات المباشر',
    region: 'المنطقة',
    status: 'الحالة',
    last_updated: 'آخر تحديث',
    map_load_error: 'تعذر تحميل الخريطة. تحقق من REACT_APP_GOOGLE_MAP_KEY والشبكة.',
    status_on_route: 'في الطريق',
    status_at_customer: 'عند العميل',
    status_idle: 'خامل',
    status_break: 'في استراحة',
};